import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import EditLearningItemForm from '../../components/EditLearningItemForm/EditLearningItemForm'
import useRoutes from '../../state/useRoutes'
import styles from './EditLearningItemPage.module.scss'
import { useLearningItem } from '../../state/entities'
import { EditLearningPathPage } from '../EditLearningPathPage/EditLearningPathPage'

export default React.memo(function EditCoursePage() {
  const routes = useRoutes()

  const { uuid, kind } = useParams()

  const handleClose = useCallback(() => routes.course.goto({ uuid: uuid! }), [routes])

  const { learningItem } = useLearningItem(uuid)

  if (kind === 'learningPath') {
    return <EditLearningPathPage learningItem={learningItem} />
  }

  return (
    <article className={styles.EditLearningItemPage}>
      <EditLearningItemForm onClose={handleClose} learningItem={learningItem} learningItemUuid={uuid!} />
    </article>
  )
})

export function EditLearningItemPageBreadcrumb() {
  const { t } = useTranslation()

  return <span>{t('edit learning.edit learning item')}</span>
}
